export { default } from './EditBot';
